import BaseService from "./BaseService";

export default class PartnerServices extends BaseService {

    public static createLiquidityPartner(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/add-liquidity-partner`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static editLiquidityPartner(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'fxAllocation/update-liquidity-partner', {
            method: 'put',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getAllLiquidityPartner(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/get-liquidity-partner-list`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UpdateLiquidityPartnerStatus(token: string, liquidityPartnerId: string, isActive: number) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/update-liquidity-partner-status/${liquidityPartnerId}/${isActive}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }

    public static createPayOutPartner(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/add-payout-partner`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getAllPayOutPartnerList(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/get-payout-partner-list`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UpdatePayOutPartnerStatus(token: string, payoutPartnerId: string, isActive: number) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/update-payout-partner-status/${payoutPartnerId}/${isActive}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }

    public static editPayoutPartner(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'fxAllocation/update-payout-partner', {
            method: 'put',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

}